import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import ListSearch from '../../list/ListSearch';

export default function FormInputListSearch(props) {
  return <FormInputSearch {...props} searchComponent={ListSearch} />;
}
